/**
 * Core
 */
import React, { useState } from "react";

/**
 *Styles
 */
import "./SelectGlobal.scss";
import cn from "classnames";
const SelectComponent = ({
  data,
  errorBirthday,
  handleChange,
  dateArray,
  customClass,
  label,
}) => {
  const [value] = useState("default");
  return (
    <div
      className={cn("select-container", customClass, `aqa-test-${customClass}`)}
    >
      <label className={`floating-label ${data ? "active" : ""}`}>
        {label}
      </label>
      <select
        className={`select-input ${data ? "active" : ""} ${
          errorBirthday ? "error" : ""
        }`}
        onChange={handleChange}
        value={data ? data : value}
      >
        <option value="default" disabled hidden />
        {dateArray.map((item, index) => (
          <option key={index} value={label === "Year" ? item : index}>
            {item || ""}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectComponent;
